module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle-group"
  }, [_c('table', [_c('tr', _vm._l((_vm.data.options), function(option) {
    return _c('td', {
      class: {
        selected: _vm.data.props.defaultValue === option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9e9915e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/approval/field-types/TOGGLE_GROUP.vue
// module id = 720
// module chunks = 0